import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { FullReloadService } from '@frontend/sports/common/core/feature/full-reload';
import { WINDOW } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class NotAuthenticatedGuard {
    private fullReloadService = inject(FullReloadService);

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.fullReloadService.fullReloadRequired) {
            // eslint-disable-next-line no-self-assign
            this._window.location.href = this._window.location.href;
        }

        return true;
    }

    private readonly _window = inject(WINDOW);
}
